<template>
    <router-view v-cloak />
</template>

<script>

import ApiService from "../api/api.service";

export default {
    name: "Teams",
    data() {
        return {
            current_team_id: null,
            teams: [],
        }
    },
    mounted() {
        this.getTeams();
        if(this.current_team_id) {
            this.showTeam();
        }
    },
    watch: {
        $route(to, from) {
            if(from.path.indexOf('teams') && to.path == '/teams') {
                this.$router.push({ path: from.path });
            }
        }
    },
    methods: {
        init() {
            if(this.$route.name != 'Teams') {
                return;
            }

            // if there are no teams associated with user go to create teams
            if(this.teams.length < 1) {
                this.goToCreateTeam();

            // if teams is selected get teams data
            } else if(this.current_team_id) {
                this.showTeam();

            // if are teams and not selected show list
            } else {
                this.showTeamsSelect();
            }
        },
        getTeams() {
            ApiService.setHeader();
            ApiService.get('/api/teams')
            .then(({data}) => {
                this.teams = data.teams;
                this.current_team_id = data.current_team_id;
                this.init();
            })
            .catch((response) => {
                console.log(response);
            })
        },

        goToCreateTeam() {
            this.$router.push({ name: 'Create Team Intro'}); // no teams
        },
        showTeamsSelect() {
            this.$router.push({ name: 'Switch Team'}); // no teams
        },
        showTeam() {
            this.$router.push({ name: 'Team Management'}); // team management
        }
    }
}
</script>

<style scoped>

</style>
